module.exports = __webpack_public_path__ + "img/driverAvatar.64f3b8e2.png";